import React from 'react';
import { useI18next } from '../../../plugins/gatsby-plugin-ap-i18next/src/useI18next';

import { checkbox } from './consents-fields.module.scss';
import { IConsent } from '../../models/consent.model';
import { getTranslation } from '../../hooks/use-translation';
import { config } from '../../config';

import Checkbox, { ICheckboxProps } from '../atoms/form/checkbox';

const { translationKeys } = config;

interface IConsentFieldsProps extends Omit<ICheckboxProps, 'label' | 'className'> {
    className?: string;
    inputClassName?: string;
    consents: IConsent[];
}

const ConsentsFields: React.FC<IConsentFieldsProps> = ({
    className = '',
    inputClassName = '',
    consents,
    name,
    identifier,
    isLight,
    boxClassName,
}) => {
    const { language, defaultLanguage } = useI18next();
    return (
        <div className={className}>
            {consents.map((consent) => {
                const { content } = getTranslation({
                    object: consent,
                    language: language,
                    defaultLanguage: defaultLanguage,
                    keys: translationKeys.consent,
                    fallbackToDefault: true,
                });
                return (
                    <Checkbox
                        key={`consent-${consent.consentId}`}
                        name={`${name}.consent${consent.consentId}.value`}
                        className={`${checkbox} ${inputClassName}`}
                        identifier={identifier}
                        label={content}
                        isLight={isLight}
                        boxClassName={boxClassName}
                    />
                );
            })}
        </div>
    );
};

export default ConsentsFields;
